module.exports = __webpack_public_path__ + "img/u1266.94b8151d.jpg";